class PillowQrCounter extends HTMLElement {
  connectedCallback() {
    this._sectionId = this.id.replace('pqc-', '');
    this.initTimezone();
    this.initAltitudeLines();
    this.initCornerMark();
  }

  /* ── Timezone → boarding pass line ── */
  initTimezone() {
    const el = this.querySelector('[data-timezone-line]');
    if (!el) return;

    const IATA_MAP = {
      'Europe/Madrid': 'MAD', 'Europe/London': 'LHR', 'Europe/Paris': 'CDG',
      'Europe/Berlin': 'BER', 'Europe/Amsterdam': 'AMS', 'Europe/Rome': 'FCO',
      'Europe/Zurich': 'ZRH', 'Europe/Vienna': 'VIE', 'Europe/Brussels': 'BRU',
      'Europe/Stockholm': 'ARN', 'Europe/Oslo': 'OSL', 'Europe/Copenhagen': 'CPH',
      'Europe/Helsinki': 'HEL', 'Europe/Dublin': 'DUB', 'Europe/Lisbon': 'LIS',
      'Europe/Athens': 'ATH', 'Europe/Warsaw': 'WAW', 'Europe/Prague': 'PRG',
      'Europe/Budapest': 'BUD', 'Europe/Bucharest': 'OTP', 'Europe/Istanbul': 'IST',
      'Europe/Moscow': 'SVO', 'Europe/Kyiv': 'KBP',
      'America/New_York': 'JFK', 'America/Los_Angeles': 'LAX', 'America/Chicago': 'ORD',
      'America/Denver': 'DEN', 'America/Phoenix': 'PHX', 'America/Houston': 'IAH',
      'America/Miami': 'MIA', 'America/Atlanta': 'ATL', 'America/Seattle': 'SEA',
      'America/Boston': 'BOS', 'America/Toronto': 'YYZ', 'America/Vancouver': 'YVR',
      'America/Montreal': 'YUL', 'America/Mexico_City': 'MEX', 'America/Sao_Paulo': 'GRU',
      'America/Argentina/Buenos_Aires': 'EZE', 'America/Lima': 'LIM',
      'America/Bogota': 'BOG', 'America/Santiago': 'SCL',
      'Asia/Tokyo': 'NRT', 'Asia/Shanghai': 'PVG', 'Asia/Hong_Kong': 'HKG',
      'Asia/Singapore': 'SIN', 'Asia/Bangkok': 'BKK', 'Asia/Dubai': 'DXB',
      'Asia/Seoul': 'ICN', 'Asia/Taipei': 'TPE', 'Asia/Kuala_Lumpur': 'KUL',
      'Asia/Jakarta': 'CGK', 'Asia/Manila': 'MNL', 'Asia/Kolkata': 'BOM',
      'Asia/Karachi': 'KHI', 'Asia/Riyadh': 'RUH',
      'Australia/Sydney': 'SYD', 'Australia/Melbourne': 'MEL',
      'Australia/Brisbane': 'BNE', 'Australia/Perth': 'PER', 'Pacific/Auckland': 'AKL',
      'Africa/Cairo': 'CAI', 'Africa/Lagos': 'LOS', 'Africa/Johannesburg': 'JNB',
      'Africa/Nairobi': 'NBO', 'Africa/Casablanca': 'CMN',
    };

    const tzToCode = (tz) => {
      if (IATA_MAP[tz]) return IATA_MAP[tz];
      const city = tz.split('/').pop().replace(/_/g, '');
      return city.slice(0, 3).toUpperCase();
    };

    const destination = (this.dataset.destination || 'SLEEP').toUpperCase();

    try {
      const tz   = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const code = tzToCode(tz);
      el.innerHTML =
        `<span class="pqc-tz__sep">ORIGIN:</span> ` +
        `<span class="pqc-tz__offset">${code}</span>` +
        `<span class="pqc-tz__sep"> → DESTINATION: </span>` +
        `<span class="pqc-tz__offset">${destination}</span>`;
    } catch (_) {
      el.textContent = `ORIGIN: ??? → DESTINATION: ${destination}`;
    }
  }

  /* ── Altitude line drift animations ── */
  initAltitudeLines() {
    const svg = this.querySelector('[data-altitude-svg]');
    if (!svg) return;
    svg.querySelectorAll('path').forEach((path, i) => {
      path.style.animationDuration = `${18 + i * 4}s`;
      path.style.animationDelay    = `${-(i * 3.2)}s`;
    });
  }

  /* ── Corner mark — live flight number ── */
  initCornerMark() {
    const el = this.querySelector('[data-corner-mark]');
    if (!el) return;
    const d   = new Date();
    const yr  = String(d.getFullYear()).slice(-2);
    const mo  = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    el.innerHTML = (this.dataset.productCode || 'PILLOW') + '<br>FLT ' + yr + mo + day;
  }
}

customElements.define('pillow-qr-counter', PillowQrCounter);

/* ── Shopify theme editor reloads ── */
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('pillow-qr-counter');
    if (el && !el.isConnected) el.connectedCallback();
  });
}
